<div
  *ngIf="Service?.openChatId;"
  [class.has-selected-message]="arSelectMessages?.length > 0"
  class="chat-inner"
  [class.has-textarea]="(interfaceService.isShowTextarea$ | async)"
>
  <!-- Chat: body -->
  <div class="chat-body d-flex flex-column h-100" [class.hidden]="interfaceService.showDetailInfo && isMobile">
    <div class="d-none d-md-block">
      <ng-content></ng-content>
    </div>
    <!-- Chat: Content-->
    <app-messages-scroll
      [demoMessage]="demoMessage"
      (onEditMessage)="editMessageText($event)"
      (onReplyMessage)="replyMessageText($event)"
      (onToggleMessage)="toggleMessage($event)"
      (onChangeLoaded)="isLoaded = $event"
      class="chat-content d-flex flex-column position-relative"
      [Service]="Service"
      [inlineMode]="true"
    >
    </app-messages-scroll>
    <!-- Chat: Content -->
    <!-- Chat: Footer -->


    <div
      [class.hidden]="isRecord || !(interfaceService.isShowTextarea$ | async)"
      class="chat-footer pt-2 pb-3"
    >
      <div class="chat-footer-blocks container-xxl">
        <div
          *ngIf="Service.editMessage && Service.editMessage.text && Service.type !== 'sender'"
          class="opacity-block chat-edit-block border-top py-2"
        >
          <div class="container-xxl">
            <div class="form-row align-items-center">
              <div class="col">
                Редактирование
                <a class="font-weight-bold pointer" (click)="scrollToMessage(Service.editMessage)">сообщения</a>
              </div>
              <div class="col-auto">
                <button (click)="editCancel()" class="nav-link btn btn-link pointer p-0">
                  <i-feather name="x" class="icon-lg pointer"></i-feather>
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-template [ngIf]="Service.replyMessage">
          <div
            *ngIf="Service.replyMessage?.text || Service.replyMessage?.text_list"
            class="opacity-block chat-reply-block border-top py-2"
          >
            <div class="form-row align-items-center">
              <div class="col-auto">
                <i-feather name="forward" class="icon-lg pointer invert"></i-feather>
              </div>
              <div class="col scroll-bottom-chat">
                <h6 class="pointer pointer m-0">
                  <ng-template [ngIf]="Service?.replyMessage?.out" [ngIfElse]="replyName">Вы</ng-template>
                  <ng-template #replyName
                  ><span
                    (click)="openDetailInfo(Service.replyMessage)"
                    [ngStyle]="{ color: Service.replyMessage.color }"
                    [innerHTML]="
                      Service.replyMessage?.name?.first + ' ' + Service.replyMessage?.name?.last
                        | replaceEmojis: 'facebook':20:64
                    "
                  ></span
                  ></ng-template>
                </h6>
                <div
                  [innerHTML]="
                  Service.replyMessage.text || Service.replyMessage.text_list | replaceEmojis: 'facebook':20:64
                "
                ></div>
              </div>
              <div class="col-auto">
                <a (click)="cancelReply()" class="nav-link pointer p-0">
                  <i-feather name="x" class="icon-lg pointer invert"></i-feather>
                </a>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="Service.forwardMessage && (interfaceService.isShowTextarea$ | async)">
          <div
            *ngIf="Service.forwardMessage?.text || Service.forwardMessage?.text_list"
            class="opacity-block chat-forward-block border-top py-2"
          >
            <div class="form-row align-items-center">
              <div class="col-auto">
                <i-feather name="corner-up-left" class="icon-lg pointer invert"></i-feather>
              </div>
              <div class="col scroll-bottom-chat">
                <h6 class="pointer pointer m-0">
                  <ng-template [ngIf]="Service?.forwardMessage?.out" [ngIfElse]="replyName">Вы</ng-template>
                  <ng-template #replyName
                  ><span
                    (click)="openDetailInfo(Service.forwardMessage)"
                    [ngStyle]="{ color: Service.forwardMessage.color }"
                    [innerHTML]="
                      Service.forwardMessage?.name?.first + ' ' + Service.forwardMessage?.name?.last
                        | replaceEmojis: 'facebook':20:64
                    "
                  ></span
                  ></ng-template>
                </h6>
                <div
                  [innerHTML]="
                  Service.forwardMessage.text || Service.forwardMessage.text_list | replaceEmojis: 'facebook':20:64
                "
                ></div>
              </div>
              <div class="col-auto">
                <a tooltip="Не пересылать сообщение" (click)="cancelForward()" class="nav-link pointer p-0">
                  <i-feather name="x" class="icon-lg pointer invert"></i-feather>
                </a>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template
          [ngIf]="resultSpellCheck?.length > 0 && spellCheckText && !allService.isTouchDevice && !interfaceService.isTelesellerDomain">
          <div class="opacity-block chat-edit-block border-top py-2">
            <div class="form-row align-items-center">
              <div class="col-auto">
                <i-feather name="edit" class="icon-lg pointer invert"></i-feather>
              </div>
              <div class="col scroll-bottom-chat">
                <h6 class="pointer pointer m-0 text-muted font-weight-bold mb-2">
                  Клик по словам для исправления ошибок или
                  <span (click)="replaceAllSpell()" class="btn-spell bg-primary">исправить все</span>
                </h6>
                <div
                  class="spellList no-invert"
                  (click)="clickSpellItem($event)"
                  [innerHTML]="spellCheckText | replaceEmojis: 'facebook':20:64"
                ></div>
              </div>
              <div class="col-auto">
                <button (click)="cancelSpellCheck()" class="nav-link btn btn-link pointer p-0">
                  <i-feather name="x" class="icon-lg pointer"></i-feather>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="container-xxl footer-voice-block">
          <app-voice
            *ngIf="isRecord"
            (onSendVoice)="addMessage($event)"
            (onClose)="onCloseVoice()"
            [Service]="Service"
          ></app-voice>
        </div>
      </div>

      <div class="container-xxl">
        <form [class.disabled]="Service.disabledMessageTextarea" [formGroup]="FormMessage">
          <div class="form-row align-items-end">
            <div class="col pl-0">
              <div (click)="messageInputClick()"
                   [class.message-input-animate]="interfaceService.isMessageInputAnimate && interfaceService.isTelesellerDomain"
                   id="message-form" class="rounded-lg position-relative">

                <ng-template [ngIf]="interfaceService.messageTextareaType === 'editor'" [ngIfElse]="textareaEditor">
                  <app-message-editor-single
                    (onFocus)="textareaFocus()"
                    (onKeyUp)="textareaKeyUp($event)"
                    (onInput)="textareaInput($event)"
                    [Service]="Service"
                    [placeholder]="Service?.messageInputText || 'Новое сообщение'">
                  </app-message-editor-single>
                </ng-template>
                <ng-template #textareaEditor>
                  <div
                    [style.height.px]="messageText.offsetHeight - 5"
                    *ngIf="isPreviewTextarea"
                    [innerHTML]="Service.message | replaceEmojis: 'facebook':16:64"
                    class="preview-textarea"
                  ></div>
                  <textarea
                    (mouseenter)="textareaMouseenter()"
                    (mouseout)="textareaMouseout()"
                    (click)="setTextAreaPosition()"
                    (keyup)="textareaKeyUp($event)"
                    (paste)="textareaPasted($event)"
                    (input)="textareaInput($event)"
                    (keyup.enter)="textareaEnter($event)"
                    (keydown.enter)="$event.preventDefault()"
                    (focus)="textareaFocus()"
                    (focusout)="textareaFocusout()"
                    autosize
                    [attr.autofocus]="!isMobile"
                    #messageText
                    [(ngModel)]="Service.message"
                    formControlName="text"
                    class="invert-filter form-control bg-transparent border-0"
                    [class.opacity-0]="isPreviewTextarea"
                    placeholder="{{Service?.messageInputText || 'Новое сообщение'}}"
                    rows="1"
                  ></textarea>
                </ng-template>
                <!-- Emoji button -->
                <!--<div *ngIf="!allService.isTouchDevice || !isMobile" class="input-group-append">
                  <button
                    tooltip="Смайлы"
                    (click)="interfaceService.showTabsInput$.next('toggle')"
                    class="btn btn-secondary btn-minimal bg-transparent border-0 px-2"
                    type="button"
                  >
                    <i-feather name="smile" class="icon-md"></i-feather>
                  </button>
                </div>-->
                <!-- Upload button -->
                <!--<div *ngIf="allService.permissionsCheck('can_send_media_messages', Service)"
                     class="input-group-append">
                  <button
                    #fileSelect
                    tooltip="Прикрепить файл, нажмите или перенесите мышкой файл в окно"
                    id="chat-upload-btn-1"
                    class="btn btn-secondary btn-minimal bg-transparent border-0 dropzone-button-js px-3"
                    type="button"
                  >
                    <i-feather name="paperclip" class="icon-md"></i-feather>
                  </button>
                </div>-->
              </div>
            </div>
            <!-- Submit button -->
            <div class="col-auto px-0 px-lg-2 pr-lg-0" [class.pr-md-10]="!interfaceService.showTabsInput">

              <!--<i-feather (click)="interfaceService.isShowTextarea$.next(false)"
                         name="bottom" class="icon-md pointer form-toggle"
                         tooltip="Скрыть поле ввода сообщения"
              ></i-feather>-->
              <button
                (click)="sendMessage($event)"
                *ngIf="
                  (Service.message?.length !== 0 || arFilesCount !== 0 || uploadFile) && !Service.editMessage || (Service.type === 'sender' && !Service.editMessage);
                  else recordBtn
                "
                class="btn btn-ico btn-primary rounded-circle position-relative"
                type="submit"
                [class.btn-circle-load]="uploadFile || isSending"
                [disabled]="uploadFile || isSending || Service.message?.length == 0"
              >
                <i-feather name="send" class="icon-md"></i-feather>
                <textarea *ngIf="allService.isTouchDevice" id="fakeSendBtn"></textarea>
                <ng-template [ngTemplateOutlet]="svg"></ng-template>
              </button>
              <ng-template #recordBtn>
                <button
                  *ngIf="!Service.editMessage"
                  (click)="startRecord()"
                  class="btn btn-ico btn-primary rounded-circle"
                  type="button"
                >
                  <i-feather name="microphone" class="icon-md"></i-feather>
                </button>
              </ng-template>
            </div>
            <!-- Save button -->
            <div *ngIf="Service.editMessage" class="col-auto px-0 px-lg-2">
              <button
                [disabled]="saveMessageDisabled()"
                (click)="saveMessage()"
                class="btn btn-ico btn-primary rounded-circle"
                type="button"
              >
                <i-feather name="save" class="icon-md"></i-feather>
              </button>
            </div>
          </div>
          <small *ngIf="Service.type === 'sender' && Service.message?.length > 1024 && arFilesCount > 0">
            <i-feather name="info" class="mr-2 text-info"></i-feather>
            Текст расылки будет отправлен вторым сообщением после файла, так как текст длинее 1024 символов.
          </small>
        </form>
      </div>
    </div>
    <!-- Chat: Footer -->
  </div>
  <!-- Chat: body -->
</div>
<!-- Chat -->


<ng-template #deleteModalContent>
  <label nz-checkbox [(ngModel)]="Service.isDeleteAllMessage">Удалить для всех</label>
</ng-template>


<ng-template #svg>
  <svg
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlns:xlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    style="display: none"
  >
    <symbol id="wave">
      <path
        d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"
      ></path>
      <path
        d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"
      ></path>
      <path
        d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"
      ></path>
      <path
        d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"
      ></path>
    </symbol>
  </svg>
</ng-template>
